module.exports = __webpack_public_path__ + "img/JND3D.png";